import DektopFooter from './DektopFooter';

export default DektopFooter;
